import httpClient from '~/lib/http-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import endpoints from './endpoints';
import { queryKeys } from './queryKeys';

export const getListContent = (): Promise<any> =>
  httpClient.json.get(endpoints.content.getContents);

export const createContent = (sectionId: string, params: FormData): Promise<any> =>
  httpClient.formData.post(endpoints.content.createContent(sectionId), params);

export const updateContent = (sectionId: string, params: any): Promise<any> =>
  httpClient.json.put(endpoints.content.updateContent(sectionId), params);

export const deleteSection = (sectionId: string): Promise<any> =>
  httpClient.json.delete(endpoints.content.deleteSection(sectionId));

export const createSection = (params: any): Promise<any> =>
  httpClient.json.post(endpoints.content.createSection, params);

export const useGetListContent = () =>
  useQuery({
    queryKey: [queryKeys.content.list],
    queryFn: () => getListContent(),
    select: (res) => res?.data,
  });

export const useCreateContentMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (resp: any) => void;
    onError?: (err: any) => void;
  } = {
    onSuccess: () => {},
    onError: () => {},
  },
) =>
  useMutation({
    mutationFn: ({ sectionId, params }: { sectionId: string; params: FormData }) =>
      createContent(sectionId, params),
    onSuccess,
    onError,
  });

export const useUpdateContentMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (resp: any) => void;
    onError?: (err: any) => void;
  } = {
    onSuccess: () => {},
    onError: () => {},
  },
) =>
  useMutation({
    mutationFn: ({ sectionId, params }: { sectionId: string; params: any }) =>
      updateContent(sectionId, params),
    onSuccess,
    onError,
  });

export const useDeleteSectionMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (resp: any) => void;
    onError?: (err: any) => void;
  } = {
    onSuccess: () => {},
    onError: () => {},
  },
) =>
  useMutation({
    mutationFn: (sectionId: string) => deleteSection(sectionId),
    onSuccess,
    onError,
  });

export const useCreateSectionMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (resp: any) => void;
    onError?: (err: any) => void;
  } = {
    onSuccess: () => {},
    onError: () => {},
  },
) =>
  useMutation({
    mutationFn: (params: any) => createSection(params),
    onSuccess,
    onError,
  });
